export default __webpack_public_path__ + "static/media/albatros3.e5e519c9.jpg";